// extracted by mini-css-extract-plugin
export default {"page":"i1-z","cartModal":"j1-z","checkout":"k1-z","placeholder":"l1-z","account":"m1-z"};